import auth from "@/auth/index"
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    children: [
      {
        path: '/configmanage',
        name: 'configmanage',
        component: resolve => require(['@/views/configmanage/index'], resolve),
        meta: {
          title: '配置管理',
          breadLevel: 0,
          icon: 'icon-config',
          auth: auth.configmanage
        }
      }
    ]
  }
]

export default routes
